import React from "react";
import "./Logo.css";

function Logo() {
  return (
    <img
      // Collez ici le lien que vous avez copié depuis Imgur
      src="https://i.imgur.com/LuF5ccK.png" // <--- MODIFIEZ CECI
      alt="Logo de l'entreprise"
      className="app-logo"
    />
  );
}

export default Logo;
